import type { AchievementsSnapshot } from "@/features/achievements/types";
import { resolveTotalHovCoreSpent } from "@/features/hoverIdle/core/cumulativeStatsResolvers";
import type { HoverIdleSnapshot } from "@/features/hoverIdle/types";
import type { Notation } from "@/shared/format/numberFormat";
import type { StatsSnapshot } from "./statsSnapshot";

export interface ComputeStatsSnapshotParams {
  readonly modelSnapshot: HoverIdleSnapshot;
  readonly achievementsSnapshot: AchievementsSnapshot;
  readonly firstPlayedAt: number | null;
  readonly lastSavedAt: number | null;
  readonly nowMs: number;
  readonly notation: Notation;
}

export function computeStatsSnapshot(
  params: ComputeStatsSnapshotParams,
): StatsSnapshot {
  const {
    modelSnapshot,
    achievementsSnapshot,
    firstPlayedAt,
    lastSavedAt,
    nowMs,
    notation,
  } = params;
  const totalPlaytimeSeconds =
    firstPlayedAt !== null ? (nowMs - firstPlayedAt) / 1000 : null;

  const normalAchievementTotal = achievementsSnapshot.entries.filter(
    (e) => e.definition.category === "normal",
  ).length;

  return {
    onlinePlaytimeSeconds: modelSnapshot.cumulativeStats.onlinePlaytimeSeconds,
    totalPlaytimeSeconds,
    currentHov: modelSnapshot.hov,
    maxHov: modelSnapshot.cumulativeStats.maxHov,
    totalTimEarned: modelSnapshot.cumulativeStats.totalTimEarned,
    mHovCount: modelSnapshot.mHov.count,
    nHovCount: modelSnapshot.nHov.count,
    oHovPower: modelSnapshot.oHov.power,
    totalHovCoreSpent: resolveTotalHovCoreSpent(modelSnapshot.cumulativeStats),
    isOHovUnlocked: modelSnapshot.oHov.isUnlocked,
    oHovFastestRunGameDurationMs: modelSnapshot.oHov.fastestRunGameDurationMs,
    oHovCurrentRunGameElapsedMs: modelSnapshot.oHov.currentRunGameElapsedMs,
    lastSavedAt,
    firstPlayedAt,
    notation,
    normalAchievementUnlocked: achievementsSnapshot.normalUnlockedCount,
    normalAchievementTotal,
    secretAchievementUnlocked: achievementsSnapshot.secretUnlockedCount,
  };
}
